import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import "../../styles/penalty-recovery.css";
import useCtaWiring from "../../hooks/useCtaWiring";
import refundBody from "./_generated/refundBody";

/** COVID Penalty Recovery — Refund & Dispute Policy (product-specific legal page). */
export default function PenaltyRecoveryRefund() {
  const rootRef = useRef(null);
  useCtaWiring(rootRef, "refund");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="pr-page pr-legal" ref={rootRef} data-testid="penalty-recovery-refund">
      <Helmet>
        <title>Refund &amp; Dispute Policy — COVID Penalty Recovery | KGOB</title>
        <meta name="description" content="Refund &amp; Dispute Policy for the KGOB COVID-Era IRS Penalty &amp; Interest Review product." />
        <link rel="canonical" href="https://kgob.com/penalty-recovery/refundanddisputepolicy" />
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: refundBody }} />
    </div>
  );
}
